import { combineReducers } from 'redux';

import volumeTrackerDashboardDataReducer from './volumeTrackerDashboardDataReducer';
import volumeTrackerDashboardUiReducer from './volumeTrackerDashboardUiReducer';

export default combineReducers({
  ui: volumeTrackerDashboardUiReducer,
  data: volumeTrackerDashboardDataReducer,
});
